<script>
	import { onMount } from "svelte";
	import { fade, blur, fly, slide, scale } from "svelte/transition";
	import RangeSlider from "svelte-range-slider-pips";
	import Buttons from "../components/Buttons.svelte";
	import Headline from "../components/Headline.svelte";

	import {
		animationParameters,
		parameters,
		parameterSections,
		months,
		slider,
		gasStopSliderValues,
		selectedSliderValues,
		gasStopFirst,
	} from "../stores.js";
	import InfoBox from "../components/InfoBox.svelte";

	const spring = { stiffness: 0.08, damping: 0.8 };

	let noGasStop = false;

	let selectedMonth;
	selectedMonth = $gasStopSliderValues;

	function toggleGasStop() {
		noGasStop = !noGasStop;
	}

	function selectGasStop() {
		noGasStop = false;
	}

	$: {
		if (noGasStop) {
			$gasStopSliderValues = [99];
		} else {
			$gasStopSliderValues = selectedMonth;
		}
	}
	let gasStopSlider;
	let gasStopSliderNub;

	onMount(async () => {
		gasStopSliderNub = document.querySelector("#slider-month").querySelector(".rangeNub");
		console.log(gasStopSliderNub);
	});

	const max = 6;

	$: if (gasStopSliderNub) {
		gasStopSliderNub.classList.toggle("left", $gasStopSliderValues.includes(0));
		gasStopSliderNub.classList.toggle("right", $gasStopSliderValues.includes(max));
	}

	// $: rangeNub = document.querySelector(".rangeNub");
	// $: console.log(gasStopSlider);

	// $: if (rangeNub)
	// 	rangeNub.addEventListener("click", () => {
	// 		console.log("rangenub");
	// 		selectGasStop;
	// });
</script>

{#each $parameterSections as s, i}
	<div class={`parameters ${s.id} box`} style="z-index: {$parameterSections.length - i + 2}">
		<div class="box-inner">
			<div class="headline">
				<Headline text={s.label} icon={s.icon} color={s.color} />
				<InfoBox content={s.infobox} />
			</div>
			{#if s.id === "incoming"}
				<div class="slider_button">
					<div class="slider" transition:fade={$animationParameters} class:disabled={noGasStop}>
						<span class="label-main">{$slider.label}</span>
						<RangeSlider
							pips
							id={$slider.id}
							all="label"
							range="max"
							hoverable={false}
							bind:values={selectedMonth}
							formatter={(v) =>
								$months[v].month === 1 || v === 0
									? `${$months[v].nameShort} ${$months[v].year.slice(-2)}`
									: $months[v].nameShort}
							{max}
							springValues={spring}
							on:change={selectGasStop}
							on:start={selectGasStop}
							on:click={() => {
								selectGasStop();
							}}
							bind:this={gasStopSlider}
						/>
					</div>
					<div class="button" on:click={toggleGasStop}>
						<div class="button-dot pip" class:selected={noGasStop}>
							<div class="pipVal">kein Lieferstopp</div>
						</div>
						{#if noGasStop}
							<div class="rangeSlider" hoverable={false} transition:fade={{ duration: 100 }}>
								<div class="rangeHandle">
									<div class="rangeNub" />
								</div>
							</div>
						{/if}
					</div>
				</div>
			{/if}

			{#each [...$parameters.filter((p) => p.dataType === s.id)].sort((a, b) => a.position - b.position) as p}
				<div
					class={`parameter ${p.dataType} parameter-${p.id}`}
					transition:fade={$animationParameters}
				>
					<div class="label">
						{#if p.dataType === "outgoing"}
							<div class="icon">
								<img src={`${PATH}${p.icon}`} />
							</div>
						{/if}
						<div class="text">
							<span class="label-main">{p.label}</span><br />
							<span class="label-sub">{p.sublabel || ""}</span>
						</div>
						<!-- <Buttons bind:value={p.selected} options={p.options} />
            -->
					</div>
					<div class="slider">
						<RangeSlider
							id={p.id}
							pips
							all="label"
							hoverable={false}
							bind:values={p.selectedSliderValue}
							formatter={(v) => p.options[v - 1].label}
							min={p.options[0].index}
							max={p.options[p.options.length - 1].index}
							springValues={spring}
						/>
					</div>
				</div>
			{/each}
		</div>
		<!-- <div class="box-arrow" /> -->
		<img src={`${PATH}images/box_arrow.svg`} class="box-arrow-image" />
	</div>
{/each}

<style lang="scss">
	.parameters {
		&.outgoing {
			.parameter-winter {
				margin-top: -10px;
			}
		}

		&.incoming {
			.slider_button {
				margin-top: -3px;
			}
		}
	}

	// Tablet view
	@media (min-width: 710px) and (max-width: 839px) {
		.incoming {
			flex-basis: 50%;
		}

		.outgoing {
			flex-basis: 50%;
		}

		.slider_button {
			.button {
				margin-left: 22px !important;

				.rangeSlider {
					left: -9px !important;
				}
			}

			.button-dot {
				left: -3px !important;
			}
		}
	}

	// max width for sliders
	@media (min-width: 420px) and (max-width: 839px) {
		.parameter {
			&.incoming {
				.slider {
					max-width: 362px;
				}
			}
			&.outgoing {
				justify-content: space-between;

				.slider {
					max-width: 362px;
				}
			}
		}
	}

	// Font size for large screens
	@media (min-width: 840px) {
		.headline {
			font-size: 20px;
		}

		.slider_button {
			.button {
				margin-left: 20px !important;

				.rangeSlider {
					left: -5px !important;
				}
			}

			.button-dot {
				left: 2px !important;
			}
		}

		.parameter {
			&.incoming {
				.slider {
					max-width: 270px;
				}
			}

			&.outgoing {
				justify-content: space-between;

				.slider {
					max-width: 222px;
				}
			}
		}

		:global(#slider-month.rangeSlider.pip-labels) {
			margin-bottom: 45px !important;
			margin-top: 33px !important;
		}

		:global(.incoming #slider-month .rangeHandle .rangeNub:after) {
			font-size: 11.5px !important;
			line-height: 11px !important;
		}

		:global(.rangeSlider.pip-labels) {
			margin-top: 24px !important;
		}

		// .label-main {
		// 	font-size: 15px;
		// 	line-height: 14px;
		// }

		// .label-sub {
		// 	font-size: 11.5px;
		// 	line-height: 11px;
		// }

		.label-main,
		.label-sub {
			font-size: 14px !important;
			line-height: 14px !important;
		}

		.text {
			font-size: 15px !important;
			line-height: 16px !important;
			min-width: 113px !important;
		}

		:global(.pipVal) {
			font-size: 12px !important;
			line-height: 11px !important;
		}
	}

	// Desktop layout
	@media (min-width: 840px) {
		.parameters {
			.box-inner {
				padding-right: 50px;
				margin-right: -25px;
			}
			&.outgoing {
				// .box-arrow {
				// 	display: none;
				// }

				.box-arrow-image {
					display: none;
				}
			}
		}
	}

	@media (min-width: 710px) and (max-width: 820px) {
		.box-inner {
			margin-bottom: 0px;
		}
	}

	// Gas Slider Pip Alignment
	@media (max-width: 419px), (min-width: 710px) and (max-width: 820px) {
		:global(#gas .pip.last > .pipVal) {
			transform: translate(-75%, 25%);
		}

		:global(#gas .pip > .pipVal) {
			transform: translate(-50%, 25%);
		}
		:global(#gas .pip.first > .pipVal) {
			transform: translate(-25%, 25%);
		}
	}

	:global(.outgoing .icon) {
		margin-left: 3px;
	}

	.headline {
		display: flex;
		justify-content: space-between;
	}

	.slider {
		width: 100%;
		// height: 4px;
		// padding-bottom: 10px;
	}

	.text {
		line-height: 10px;
		min-width: 100px;
		letter-spacing: 0.01em;
		margin-right: 10px;
	}

	.icon {
		width: 27px;
	}

	.label {
		display: flex;
		align-items: center;
		column-gap: 5px;
	}

	.label-main {
		font-weight: 600;
		font-size: 13px;
		line-height: 14px;
		letter-spacing: 0.005em;
	}

	.parameter.incoming {
		.slider {
			margin-left: 8px;
			width: calc(100% - 8px);
		}
	}

	.incoming .label-main {
		margin-left: 10px;
	}

	.label-sub {
		color: #868686;
		font-weight: 500;
		font-size: 11.5px;
		line-height: 11px;
		letter-spacing: 0.03em;
	}

	.parameter.outgoing {
		display: flex;
	}

	.buttons {
		width: 100%;
	}

	:global(#slider-month .pip.last > .pipVal) {
		transform: translate(-100%, 25%);
	}

	:global(#slider-month .pip.first > .pipVal) {
		transform: translate(0%, 25%);
	}

	:global(.pipVal) {
		font-weight: 500;
		font-size: 11.5px;
		line-height: 11px;
		letter-spacing: 0.04em;
		color: #bdb9b9;
	}

	:global(.pip) {
		box-shadow: none !important;
	}

	:global(#slider-month .pipVal) {
		// font-weight: 400;
		font-size: 10px;
		line-height: 11px;
		// letter-spacing: 0.04em;
		letter-spacing: 0;
		// color: #2a2a2a;
	}

	:global(#slider-month .rangePips .pip) {
		height: 3px !important;
		background-color: #bdb9b9 !important;
	}

	:global(#slider-month.rangeSlider.pip-labels) {
		margin-bottom: 42px !important;
		margin-top: 28px;
	}

	:global(.rangeSlider) {
		height: 4px !important;
		background-color: #c1c1c1 !important;
		cursor: pointer;
		margin: 1.2em 1em 1em 1em;
		-webkit-tap-highlight-color: transparent;
		user-select: none;
	}

	:global(.rangeBar) {
		height: 4px !important;
	}

	:global(.rangeHandle) {
		top: 2px !important;
	}

	:global(.rangeNub) {
		width: 10px !important;
		height: 10px !important;
		transform: translate(50%, 50%) !important;
	}

	:global(.rangeSlider.pip-labels) {
		margin-bottom: 28px !important;
	}

	:global(.rangeSlider .rangeHandle::before) {
		width: 22px !important;
		height: 22px !important;
		left: -2px !important;
		top: -2px !important;
		border-radius: 100% !important;
		border: 1px solid #c1c1c1;
		opacity: 1 !important;
		background-color: #fff;
		box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25) !important;
		outline: none !important;
	}

	$stop-color: #868686;
	$incoming-color: #5868f9;
	$outgoing-color: #f26546;

	:global(.incoming .rangeSlider .rangeHandle::before) {
		border: 1px solid $stop-color;
	}

	:global(.button .rangeSlider .rangeHandle::before) {
		border: 1px solid $incoming-color;
	}

	:global(.incoming .parameter .rangeSlider .rangeHandle::before) {
		border: 1px solid $incoming-color;
	}

	:global(.outgoing .parameter .rangeSlider .rangeHandle::before) {
		border: 1px solid $outgoing-color;
	}

	:global(.incoming .selected .pipVal) {
		color: $incoming-color;
		font-weight: 500 !important;
	}

	:global(#slider-month .selected .pipVal) {
		color: $stop-color;
		font-weight: 500 !important;
	}

	:global(.outgoing .selected .pipVal) {
		color: $outgoing-color;
		font-weight: 500 !important;
	}

	:global(.incoming .rangeHandle .rangeNub),
	:global(.incoming .rangeBar),
	:global(.incoming .rangeHandle.active .rangeNub) {
		background-color: $incoming-color !important;
	}

	:global(.outgoing .rangeHandle .rangeNub),
	:global(.outgoing .rangeBar),
	:global(.outgoing .rangeHandle.active .rangeNub) {
		background-color: $outgoing-color !important;
	}

	:global(.incoming #slider-month .rangeHandle .rangeNub),
	:global(.incoming #slider-month .rangeBar),
	:global(.incoming #slider-month .rangeHandle.active .rangeNub) {
		background-color: $stop-color !important;
	}

	:global(.incoming #slider-month.rangeSlider) {
		background-color: $incoming-color !important;
		left: 8px;
	}

	:global(.parameter .pip) {
		border-radius: 100%;
		width: 12px !important;
		height: 12px !important;
		transform: translate(-50%, -12px);
		background: #ffffff !important;
		border: 1px solid #c1c1c1 !important;
		box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25) !important;
	}
	:global(.parameter .pip.selected) {
		height: 12px;
		color: #fff;
		background-color: #fff;
	}
	:global(.parameter .pip::after) {
		content: "";
		border-radius: 100%;
		width: 8px;
		height: 8px;
		top: 2px;
		left: 2px;
		position: absolute;
		background: #ffffff;
		box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.25);
	}
	:global(.parameter .rangePips) {
		// bottom: 0 !important;
	}
	:global(.parameter .pip .pipVal) {
		top: 18px !important;
		transform: translate(calc(-50% + 6px), 25%);
		// transform: translate(-50%, 25%);
	}
	:global(.rangeSlider.hoverable:not(.disabled) .rangeHandle.press:before),
	:global(.rangeSlider.hoverable:not(.disabled) .rangeHandle.press:hover:before) {
		box-shadow: none !important;
	}

	:global(.incoming #slider-month .rangeHandle .rangeNub:after) {
		content: "Lieferstopp";
		font-weight: 500;
		font-size: 11.5px;
		line-height: 11px;
		letter-spacing: 0.04em;
		color: #868686;
		transform: translate(calc(-50% + 5px), -22px);
		transition: transform 0.3s ease-out;
		position: absolute;
	}

	:global(.incoming #slider-month .rangeHandle .rangeNub.left:after) {
		transform: translate(-7px, -22px);
	}

	:global(.incoming #slider-month .rangeHandle .rangeNub.right:after) {
		transform: translate(calc(-100% + 15px), -22px);
	}

	.slider_button {
		display: flex;
		flex-wrap: nowrap;
	}

	.slider_button .slider {
		flex: 1 0 1px;
	}

	.slider_button .button {
		flex: 0 0 24px;
		position: relative;
		margin-left: 34px;
	}

	.slider_button .button-dot {
		bottom: 37px;
		position: absolute;
		left: -7px;
		border-radius: 100%;
		width: 12px;
		height: 12px;
		background: #ffffff;
		border: 1px solid #c1c1c1;
		box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25) !important;

		&:after {
			content: "";
			border-radius: 100%;
			width: 8px;
			height: 8px;
			top: 2px;
			left: 2px;
			position: absolute;
			background: #ffffff;
			box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.25);
		}
	}

	.slider_button .button .rangeSlider {
		position: absolute;
		bottom: 29px;
		left: -14px;
		transform: none;
	}

	.button {
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
		user-select: none;
	}

	.slider_button .slider.disabled :global(.rangeSlider .rangeHandle) {
		opacity: 0;
	}

	:global(.incoming .slider_button .slider.disabled #slider-month.rangeSlider),
	:global(.incoming .slider_button .slider.disabled #slider-month .rangeBar) {
		background: #c1c1c1 !important;
	}
	:global(.incoming .slider_button .slider.disabled #slider-month .pipVal) {
		color: #868686 !important;
	}

	:global(.incoming .slider_button .slider.disabled .selected .pipVal) {
		font-weight: 400 !important;
		top: 0.4em !important;
	}

	.button-dot .pipVal {
		position: absolute;
		width: auto;
		top: 20px;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;
		font-size: 10px;
		line-height: 11px;
		letter-spacing: 0.01px;
		// color: #2a2a2a;
		// font-weight: 400;
		transition: transform 0.3s;
	}

	.selected.button-dot .pipVal {
		transform: translate(-50%, 5px);
	}
</style>
